export default __webpack_public_path__ + "static/media/cart-empty.66edd3e7.png";